import React from "react";
import { Modal } from "antd";

const TransactionRequestModal = ({
  receiptCollections,
  userAccountNo,
  onApprove,
}) => {
  const showModal = () => {
    if (!userAccountNo) {
      // Show warning modal about missing account number
      Modal.confirm({
        title: "Transaction Request Approval - No Account Number",
        width: 700,
        content: (
          <div>
            <p
              style={{
                fontWeight: "bold",
                color: "#ff4d4f",
                marginBottom: 16,
              }}
            >
              ⚠️ You don't have an account number assigned!
            </p>
            <p style={{ marginBottom: 16 }}>
              The following {receiptCollections.length} transaction(s) are
              Transaction Requests:
            </p>
            <TransactionTable transactions={receiptCollections} />
            <p style={{ marginTop: 8 }}>
              Note: Items with <strong>Reference = BANK</strong> are bank transactions and will not change the approver account.
            </p>
            <p style={{ color: "#1890ff" }}>
              ℹ️ Press "Continue" to approve these transactions without debiting
              to your account, or "Cancel" to stop the approval process.
            </p>
          </div>
        ),
        okText: "Continue to Approve",
        cancelText: "Cancel",
        onOk: () => onApprove(null),
      });
    } else {
      // Show confirmation modal with account number
      Modal.confirm({
        title: "Transaction Request Approval",
        width: 700,
        content: (
          <div>
            <p style={{ fontWeight: "bold", marginBottom: 16 }}>
              📋 {receiptCollections.length} Transaction Request(s) detected:
            </p>
            <TransactionTable transactions={receiptCollections} />
            <p style={{ marginTop: 8 }}>
              Note: Items with <strong>Reference = BANK</strong> are bank transactions and will not change the approver account.
            </p>
            <p
              style={{
                backgroundColor: "#e6f7ff",
                padding: 12,
                borderRadius: 4,
                marginBottom: 8,
              }}
            >
              <strong>Your Account Number:</strong>{" "}
              <span style={{ color: "#1890ff" }}>{userAccountNo}</span>
            </p>
            <p style={{ color: "#52c41a" }}>
              ✓ These amounts will be debited from your account upon approval.
            </p>
          </div>
        ),
        okText: "Approve & Debit My Account",
        cancelText: "Cancel",
        onOk: () => onApprove(userAccountNo),
      });
    }
  };

  return { showModal };
};

const TransactionTable = ({ transactions }) => {
  return (
    <div
      style={{
        maxHeight: 300,
        overflowY: "auto",
        marginBottom: 16,
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th style={{ padding: 8, border: "1px solid #d9d9d9" }}>From</th>
            <th style={{ padding: 8, border: "1px solid #d9d9d9" }}>Amount</th>
            <th style={{ padding: 8, border: "1px solid #d9d9d9" }}>Reason</th>
            <th style={{ padding: 8, border: "1px solid #d9d9d9" }}>Type</th>
            <th style={{ padding: 8, border: "1px solid #d9d9d9" }}>Reference</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((txn) => (
            <tr key={txn.id}>
              <td style={{ padding: 8, border: "1px solid #d9d9d9" }}>
                {txn.fromName}
              </td>
              <td style={{ padding: 8, border: "1px solid #d9d9d9" }}>
                {txn.amount}
              </td>
              <td style={{ padding: 8, border: "1px solid #d9d9d9" }}>
                {txn.reason}
              </td>
              <td style={{ padding: 8, border: "1px solid #d9d9d9" }}>
                {txn.type}
              </td>
              <td style={{ padding: 8, border: "1px solid #d9d9d9" }}>
                {(txn.reference || "").toString()}
                {txn.reference?.toString().toLowerCase() === "bank" ? (
                  <span style={{ marginLeft: 8, color: "#faad14" }}>
                    Bank transaction (destination account unchanged)
                  </span>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionRequestModal;
